import { serviceBase } from "../../../service";
import { clearance } from "../../../service";

const TariffModifiers = {
  ...serviceBase,
  clearance,
  resource: "tariff-modifiers",
  preList: function(params) {
    delete params.id;
    return `projects/${params.project_id || "-"}`;
  },
  preListOption: {
    getList: true,
    get: true,
    create: true,
    update: true,
    delete: true,
    deleteList: true
  }
};

export default TariffModifiers;
